import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity,
  TrialBalanceItem, Jaarrekening, Jaarrapportage, BokkzJrLogic
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-kortlopende-schulden',
  templateUrl: './spec-kortlopende-schulden.component.html',
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SpecTrialbalanceComponent,
    SpecFormattedexplanationComponent,
    CommonModule
  ],
  styleUrls: ['./spec-kortlopende-schulden.component.scss']
})
export class SpecKortlopendeSchuldenComponent implements OnInit,OnChanges,OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public liabilitiesCurrentFg = {} as FormGroup;
  public convertibleBorrowingsCurrentFg = {} as FormGroup;
  public debenturesOtherPrivateLoansCurrentFg = {} as FormGroup;
  public financeLeaseLiabilitiesCurrentFg = {} as FormGroup;
  public payablesBanksCurrentFg = {} as FormGroup;
  public advancesReceivedCurrentFg = {} as FormGroup;
  public tradePayablesCurrentFg = {} as FormGroup;
  public billsExchangeChequesPayableCurrentFg = {} as FormGroup;
  public payablesGroupCompaniesCurrentFg = {} as FormGroup;
  public payablesOtherAffiliatedCompaniesCurrentFg = {} as FormGroup;
  public payablesShareholdersParticipatingInterestsCurrentFg = {} as FormGroup;
  public taxesSocialSecurityContributionsPayableCurrentFg = {} as FormGroup;
  public payablesIncomeTaxCurrentFg = {} as FormGroup;
  public pensionPayablesCurrentFg = {} as FormGroup;
  public repaymentObligationsOfNoncurrentBorrowingsFg = {} as FormGroup;
  public dividendPayableHoldersSharesRecordedAsLiabilityFg = {} as FormGroup;
  public constructionContractsLiabilitiesFg = {} as FormGroup;
  public payablesEmployeeBenefitsExpensesFg = {} as FormGroup;
  public payablesVacationDaysFg = {} as FormGroup;
  public payablesHolidayPayFg = {} as FormGroup;
  public dividendPayableHoldersPreferredSharesFg = {} as FormGroup;
  public payablesOtherCurrentFg = {} as FormGroup;
  public accrualsAndDeferredIncomeCurrentFg = {} as FormGroup;

  public liabilitiesCurrentDisclosureFg = {} as FormGroup;
  public convertibleBorrowingsCurrentDisclosureFg = {} as FormGroup;
  public debenturesOtherPrivateLoansCurrentDisclosureFg = {} as FormGroup;
  public financeLeaseLiabilitiesCurrentDisclosureFg = {} as FormGroup;
  public payablesBanksCurrentDisclosureFg = {} as FormGroup;
  public advancesReceivedCurrentDisclosureFg = {} as FormGroup;
  public tradePayablesCurrentDisclosureFg = {} as FormGroup;
  public billsExchangeChequesPayableCurrentDisclosureFg = {} as FormGroup;
  public payablesGroupCompaniesCurrentDisclosureFg = {} as FormGroup;
  public payablesOtherAffiliatedCompaniesCurrentDisclosureFg = {} as FormGroup;
  public payablesShareholdersParticipatingInterestsCurrentDisclosureFg = {} as FormGroup;
  public payablesIncomeTaxCurrentDisclosureFg = {} as FormGroup;
  public taxesSocialSecurityContributionsPayableCurrentDisclosureFg = {} as FormGroup;
  public pensionPayablesCurrentDisclosureFg = {} as FormGroup;
  public repaymentObligationsOfNoncurrentBorrowingsDisclosureFg = {} as FormGroup;
  public dividendPayableHoldersSharesRecordedAsLiabilityDisclosureFg = {} as FormGroup;
  public constructionContractsLiabilitiesDisclosureFg = {} as FormGroup;
  public payablesEmployeeBenefitsExpensesDisclosureFg = {} as FormGroup;
  public payablesVacationDaysDisclosureFg = {} as FormGroup;
  public payablesHolidayPayDisclosureFg = {} as FormGroup;
  public dividendPayableHoldersPreferredSharesDisclosureFg = {} as FormGroup;
  public payablesOtherCurrentDisclosureFg = {} as FormGroup;
  public accrualsAndDeferredIncomeCurrentDisclosureFg = {} as FormGroup;
  public liabilitiesCurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosureFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.liabilitiesCurrentFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues();
    this.convertibleBorrowingsCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.debenturesOtherPrivateLoansCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.financeLeaseLiabilitiesCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.payablesBanksCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.advancesReceivedCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.tradePayablesCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.billsExchangeChequesPayableCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.payablesGroupCompaniesCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.payablesOtherAffiliatedCompaniesCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.payablesShareholdersParticipatingInterestsCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.taxesSocialSecurityContributionsPayableCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.payablesIncomeTaxCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.pensionPayablesCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.repaymentObligationsOfNoncurrentBorrowingsFg = this.jrDataService.createFormGroupBalanceItem();
    this.dividendPayableHoldersSharesRecordedAsLiabilityFg = this.jrDataService.createFormGroupBalanceItem();
    this.constructionContractsLiabilitiesFg = this.jrDataService.createFormGroupBalanceItem();
    this.payablesEmployeeBenefitsExpensesFg = this.jrDataService.createFormGroupBalanceItem();
    this.payablesVacationDaysFg = this.jrDataService.createFormGroupBalanceItem();
    this.payablesHolidayPayFg = this.jrDataService.createFormGroupBalanceItem();
    this.dividendPayableHoldersPreferredSharesFg = this.jrDataService.createFormGroupBalanceItem();
    this.payablesOtherCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.accrualsAndDeferredIncomeCurrentFg = this.jrDataService.createFormGroupBalanceItem();

    this.liabilitiesCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.convertibleBorrowingsCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.debenturesOtherPrivateLoansCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.financeLeaseLiabilitiesCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.payablesBanksCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.advancesReceivedCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.tradePayablesCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.billsExchangeChequesPayableCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.payablesGroupCompaniesCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.payablesOtherAffiliatedCompaniesCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.payablesShareholdersParticipatingInterestsCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.payablesIncomeTaxCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.taxesSocialSecurityContributionsPayableCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.pensionPayablesCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.repaymentObligationsOfNoncurrentBorrowingsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.dividendPayableHoldersSharesRecordedAsLiabilityDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.constructionContractsLiabilitiesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.payablesEmployeeBenefitsExpensesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.payablesVacationDaysDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.payablesHolidayPayDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.dividendPayableHoldersPreferredSharesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.payablesOtherCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.accrualsAndDeferredIncomeCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.liabilitiesCurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {
    const kortlopendeSchulden = value.rapportage?.jaarrekeningen?.at(0)?.balans?.kortlopendeSchulden;

    if (kortlopendeSchulden) {
      this.liabilitiesCurrentFg.reset();

      if (kortlopendeSchulden.liabilitiesCurrent) {
        this.liabilitiesCurrentFg.patchValue(kortlopendeSchulden.liabilitiesCurrent, {emitEvent: false})
      }

      const uitsplitsing = kortlopendeSchulden.kortlopendeSchuldenUitsplitsing;
      const tekstueel = kortlopendeSchulden.kortlopendeSchuldenTekstueel;
      if (uitsplitsing) {
        if (uitsplitsing.convertibleBorrowingsCurrent) {
          const subItem = uitsplitsing.convertibleBorrowingsCurrent;
          this.convertibleBorrowingsCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.convertibleBorrowingsCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.debenturesOtherPrivateLoansCurrent) {
          const subItem = uitsplitsing.debenturesOtherPrivateLoansCurrent;
          this.debenturesOtherPrivateLoansCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.debenturesOtherPrivateLoansCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.financeLeaseLiabilitiesCurrent) {
          const subItem = uitsplitsing.financeLeaseLiabilitiesCurrent;
          this.financeLeaseLiabilitiesCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.financeLeaseLiabilitiesCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.payablesBanksCurrent) {
          const subItem = uitsplitsing.payablesBanksCurrent;
          this.payablesBanksCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.payablesBanksCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.advancesReceivedCurrent) {
          const subItem = uitsplitsing.advancesReceivedCurrent;
          this.advancesReceivedCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.advancesReceivedCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.tradePayablesCurrent) {
          const subItem = uitsplitsing.tradePayablesCurrent;
          this.tradePayablesCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.tradePayablesCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.billsExchangeChequesPayableCurrent) {
          const subItem = uitsplitsing.billsExchangeChequesPayableCurrent;
          this.billsExchangeChequesPayableCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.billsExchangeChequesPayableCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.payablesGroupCompaniesCurrent) {
          const subItem = uitsplitsing.payablesGroupCompaniesCurrent;
          this.payablesGroupCompaniesCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.payablesGroupCompaniesCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.payablesOtherAffiliatedCompaniesCurrent) {
          const subItem = uitsplitsing.payablesOtherAffiliatedCompaniesCurrent;
          this.payablesOtherAffiliatedCompaniesCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.payablesOtherAffiliatedCompaniesCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.payablesShareholdersParticipatingInterestsCurrent) {
          const subItem = uitsplitsing.payablesShareholdersParticipatingInterestsCurrent;
          this.payablesShareholdersParticipatingInterestsCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.payablesShareholdersParticipatingInterestsCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.taxesSocialSecurityContributionsPayableCurrent) {
          const subItem = uitsplitsing.taxesSocialSecurityContributionsPayableCurrent;
          this.taxesSocialSecurityContributionsPayableCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.taxesSocialSecurityContributionsPayableCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.payablesIncomeTaxCurrent) {
          const subItem = uitsplitsing.payablesIncomeTaxCurrent;
          this.payablesIncomeTaxCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.payablesIncomeTaxCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.pensionPayablesCurrent) {
          const subItem = uitsplitsing.pensionPayablesCurrent;
          this.pensionPayablesCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.pensionPayablesCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.repaymentObligationsOfNoncurrentBorrowings) {
          const subItem = uitsplitsing.repaymentObligationsOfNoncurrentBorrowings;
          this.repaymentObligationsOfNoncurrentBorrowingsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.repaymentObligationsOfNoncurrentBorrowingsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.dividendPayableHoldersSharesRecordedAsLiability) {
          const subItem = uitsplitsing.dividendPayableHoldersSharesRecordedAsLiability;
          this.dividendPayableHoldersSharesRecordedAsLiabilityFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.dividendPayableHoldersSharesRecordedAsLiabilityFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.constructionContractsLiabilities) {
          const subItem = uitsplitsing.constructionContractsLiabilities;
          this.constructionContractsLiabilitiesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.constructionContractsLiabilitiesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.payablesEmployeeBenefitsExpenses) {
          const subItem = uitsplitsing.payablesEmployeeBenefitsExpenses;
          this.payablesEmployeeBenefitsExpensesFg.patchValue(subItem);
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.payablesEmployeeBenefitsExpensesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.payablesVacationDays) {
          const subItem = uitsplitsing.payablesVacationDays;
          this.payablesVacationDaysFg.patchValue(subItem);
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.payablesVacationDaysFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.payablesHolidayPay) {
          const subItem = uitsplitsing.payablesHolidayPay;
          this.payablesHolidayPayFg.patchValue(subItem);
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.payablesHolidayPayFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.dividendPayableHoldersPreferredShares) {
          const subItem = uitsplitsing.dividendPayableHoldersPreferredShares;
          this.dividendPayableHoldersPreferredSharesFg.patchValue(subItem);
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.dividendPayableHoldersPreferredSharesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.payablesOtherCurrent) {
          const subItem = uitsplitsing.payablesOtherCurrent;
          this.payablesOtherCurrentFg.patchValue(subItem);
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.payablesOtherCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.accrualsAndDeferredIncomeCurrent) {
          const subItem = uitsplitsing.accrualsAndDeferredIncomeCurrent;
          this.accrualsAndDeferredIncomeCurrentFg.patchValue(subItem);
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.accrualsAndDeferredIncomeCurrentFg.get('trialBalanceItems') as FormArray)
        }
      }
      if (tekstueel) {
        if (tekstueel.liabilitiesCurrentDisclosure) {
          this.liabilitiesCurrentDisclosureFg.patchValue(tekstueel.liabilitiesCurrentDisclosure);
        }
        if (tekstueel.convertibleBorrowingsCurrentDisclosure) {
          this.convertibleBorrowingsCurrentDisclosureFg.patchValue(tekstueel.convertibleBorrowingsCurrentDisclosure);
        }
        if (tekstueel.debenturesOtherPrivateLoansCurrentDisclosure) {
          this.debenturesOtherPrivateLoansCurrentDisclosureFg.patchValue(tekstueel.debenturesOtherPrivateLoansCurrentDisclosure);
        }
        if (tekstueel.financeLeaseLiabilitiesCurrentDisclosure) {
          this.financeLeaseLiabilitiesCurrentDisclosureFg.patchValue(tekstueel.financeLeaseLiabilitiesCurrentDisclosure);
        }
        if (tekstueel.payablesBanksCurrentDisclosure) {
          this.payablesBanksCurrentDisclosureFg.patchValue(tekstueel.payablesBanksCurrentDisclosure);
        }
        if (tekstueel.advancesReceivedCurrentDisclosure) {
          this.advancesReceivedCurrentDisclosureFg.patchValue(tekstueel.advancesReceivedCurrentDisclosure);
        }
        if (tekstueel.tradePayablesCurrentDisclosure) {
          this.tradePayablesCurrentDisclosureFg.patchValue(tekstueel.tradePayablesCurrentDisclosure);
        }
        if (tekstueel.billsExchangeChequesPayableCurrentDisclosure) {
          this.billsExchangeChequesPayableCurrentDisclosureFg.patchValue(tekstueel.billsExchangeChequesPayableCurrentDisclosure);
        }
        if (tekstueel.payablesGroupCompaniesCurrentDisclosure) {
          this.payablesGroupCompaniesCurrentDisclosureFg.patchValue(tekstueel.payablesGroupCompaniesCurrentDisclosure);
        }
        if (tekstueel.payablesOtherAffiliatedCompaniesCurrentDisclosure) {
          this.payablesOtherAffiliatedCompaniesCurrentDisclosureFg.patchValue(tekstueel.payablesOtherAffiliatedCompaniesCurrentDisclosure);
        }
        if (tekstueel.payablesShareholdersParticipatingInterestsCurrentDisclosure) {
          this.payablesShareholdersParticipatingInterestsCurrentDisclosureFg.patchValue(tekstueel.payablesShareholdersParticipatingInterestsCurrentDisclosure);
        }
        if (tekstueel.payablesIncomeTaxCurrentDisclosure) {
          this.payablesIncomeTaxCurrentDisclosureFg.patchValue(tekstueel.payablesIncomeTaxCurrentDisclosure);
        }
        if (tekstueel.taxesSocialSecurityContributionsPayableCurrentDisclosure) {
          this.taxesSocialSecurityContributionsPayableCurrentDisclosureFg.patchValue(tekstueel.taxesSocialSecurityContributionsPayableCurrentDisclosure);
        }
        if (tekstueel.pensionPayablesCurrentDisclosure) {
          this.pensionPayablesCurrentDisclosureFg.patchValue(tekstueel.pensionPayablesCurrentDisclosure);
        }
        if (tekstueel.repaymentObligationsOfNoncurrentBorrowingsDisclosure) {
          this.repaymentObligationsOfNoncurrentBorrowingsDisclosureFg.patchValue(tekstueel.repaymentObligationsOfNoncurrentBorrowingsDisclosure);
        }
        if (tekstueel.dividendPayableHoldersSharesRecordedAsLiabilityDisclosure) {
          this.dividendPayableHoldersSharesRecordedAsLiabilityDisclosureFg.patchValue(tekstueel.dividendPayableHoldersSharesRecordedAsLiabilityDisclosure);
        }
        if (tekstueel.constructionContractsLiabilitiesDisclosure) {
          this.constructionContractsLiabilitiesDisclosureFg.patchValue(tekstueel.constructionContractsLiabilitiesDisclosure);
        }
        if (tekstueel.payablesEmployeeBenefitsExpensesDisclosure) {
          this.payablesEmployeeBenefitsExpensesDisclosureFg.patchValue(tekstueel.payablesEmployeeBenefitsExpensesDisclosure);
        }
        if (tekstueel.payablesVacationDaysDisclosure) {
          this.payablesVacationDaysDisclosureFg.patchValue(tekstueel.payablesVacationDaysDisclosure);
        }
        if (tekstueel.payablesHolidayPayDisclosure) {
          this.payablesHolidayPayDisclosureFg.patchValue(tekstueel.payablesHolidayPayDisclosure);
        }
        if (tekstueel.dividendPayableHoldersPreferredSharesDisclosure) {
          this.dividendPayableHoldersPreferredSharesDisclosureFg.patchValue(tekstueel.dividendPayableHoldersPreferredSharesDisclosure);
        }
        if (tekstueel.payablesOtherCurrentDisclosure) {
          this.payablesOtherCurrentDisclosureFg.patchValue(tekstueel.payablesOtherCurrentDisclosure);
        }
        if (tekstueel.accrualsAndDeferredIncomeCurrentDisclosure) {
          this.accrualsAndDeferredIncomeCurrentDisclosureFg.patchValue(tekstueel.accrualsAndDeferredIncomeCurrentDisclosure);
        }
        if (tekstueel.liabilitiesCurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosure) {
          this.liabilitiesCurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosureFg.patchValue(tekstueel.liabilitiesCurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosure);
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i]);
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup);
        }
      }
    }
  }

  saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    this.liabilitiesCurrentFg.updateValueAndValidity();
    this.convertibleBorrowingsCurrentFg.updateValueAndValidity();
    this.debenturesOtherPrivateLoansCurrentFg.updateValueAndValidity();
    this.financeLeaseLiabilitiesCurrentFg.updateValueAndValidity();
    this.payablesBanksCurrentFg.updateValueAndValidity();
    this.advancesReceivedCurrentFg.updateValueAndValidity();
    this.tradePayablesCurrentFg.updateValueAndValidity();
    this.billsExchangeChequesPayableCurrentFg.updateValueAndValidity();
    this.payablesGroupCompaniesCurrentFg.updateValueAndValidity();
    this.payablesOtherAffiliatedCompaniesCurrentFg.updateValueAndValidity();
    this.payablesShareholdersParticipatingInterestsCurrentFg.updateValueAndValidity();
    this.taxesSocialSecurityContributionsPayableCurrentFg.updateValueAndValidity();
    this.payablesIncomeTaxCurrentFg.updateValueAndValidity();
    this.pensionPayablesCurrentFg.updateValueAndValidity();
    this.repaymentObligationsOfNoncurrentBorrowingsFg.updateValueAndValidity();
    this.dividendPayableHoldersSharesRecordedAsLiabilityFg.updateValueAndValidity();
    this.constructionContractsLiabilitiesFg.updateValueAndValidity();
    this.payablesEmployeeBenefitsExpensesFg.updateValueAndValidity();
    this.payablesVacationDaysFg.updateValueAndValidity();
    this.payablesHolidayPayFg.updateValueAndValidity();
    this.dividendPayableHoldersPreferredSharesFg.updateValueAndValidity();
    this.payablesOtherCurrentFg.updateValueAndValidity();
    this.accrualsAndDeferredIncomeCurrentFg.updateValueAndValidity();

    this.liabilitiesCurrentDisclosureFg.updateValueAndValidity();
    this.convertibleBorrowingsCurrentDisclosureFg.updateValueAndValidity();
    this.debenturesOtherPrivateLoansCurrentDisclosureFg.updateValueAndValidity();
    this.financeLeaseLiabilitiesCurrentDisclosureFg.updateValueAndValidity();
    this.payablesBanksCurrentDisclosureFg.updateValueAndValidity();
    this.advancesReceivedCurrentDisclosureFg.updateValueAndValidity();
    this.tradePayablesCurrentDisclosureFg.updateValueAndValidity();
    this.billsExchangeChequesPayableCurrentDisclosureFg.updateValueAndValidity();
    this.payablesGroupCompaniesCurrentDisclosureFg.updateValueAndValidity();
    this.payablesOtherAffiliatedCompaniesCurrentDisclosureFg.updateValueAndValidity();
    this.payablesShareholdersParticipatingInterestsCurrentDisclosureFg.updateValueAndValidity();
    this.payablesIncomeTaxCurrentDisclosureFg.updateValueAndValidity();
    this.taxesSocialSecurityContributionsPayableCurrentDisclosureFg.updateValueAndValidity();
    this.pensionPayablesCurrentDisclosureFg.updateValueAndValidity();
    this.repaymentObligationsOfNoncurrentBorrowingsDisclosureFg.updateValueAndValidity();
    this.dividendPayableHoldersSharesRecordedAsLiabilityDisclosureFg.updateValueAndValidity();
    this.constructionContractsLiabilitiesDisclosureFg.updateValueAndValidity();
    this.payablesEmployeeBenefitsExpensesDisclosureFg.updateValueAndValidity();
    this.payablesVacationDaysDisclosureFg.updateValueAndValidity();
    this.payablesHolidayPayDisclosureFg.updateValueAndValidity();
    this.dividendPayableHoldersPreferredSharesDisclosureFg.updateValueAndValidity();
    this.payablesOtherCurrentDisclosureFg.updateValueAndValidity();
    this.accrualsAndDeferredIncomeCurrentDisclosureFg.updateValueAndValidity();
    this.liabilitiesCurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosureFg.updateValueAndValidity();

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        balans: {
          ...this.jrEntity.rapportage.jaarrekeningen[0].balans,
          kortlopendeSchulden: {
            ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.kortlopendeSchulden,
            kortlopendeSchuldenUitsplitsing: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.kortlopendeSchulden?.kortlopendeSchuldenUitsplitsing,
              convertibleBorrowingsCurrent: this.convertibleBorrowingsCurrentFg.value,
              debenturesOtherPrivateLoansCurrent: this.debenturesOtherPrivateLoansCurrentFg.value,
              financeLeaseLiabilitiesCurrent: this.financeLeaseLiabilitiesCurrentFg.value,
              payablesBanksCurrent: this.payablesBanksCurrentFg.value,
              advancesReceivedCurrent: this.advancesReceivedCurrentFg.value,
              tradePayablesCurrent: this.tradePayablesCurrentFg.value,
              billsExchangeChequesPayableCurrent: this.billsExchangeChequesPayableCurrentFg.value,
              payablesGroupCompaniesCurrent: this.payablesGroupCompaniesCurrentFg.value,
              payablesOtherAffiliatedCompaniesCurrent: this.payablesOtherAffiliatedCompaniesCurrentFg.value,
              payablesShareholdersParticipatingInterestsCurrent: this.payablesShareholdersParticipatingInterestsCurrentFg.value,
              taxesSocialSecurityContributionsPayableCurrent: this.taxesSocialSecurityContributionsPayableCurrentFg.value,
              payablesIncomeTaxCurrent: this.payablesIncomeTaxCurrentFg.value,
              pensionPayablesCurrent: this.pensionPayablesCurrentFg.value,
              repaymentObligationsOfNoncurrentBorrowings: this.repaymentObligationsOfNoncurrentBorrowingsFg.value,
              dividendPayableHoldersSharesRecordedAsLiability: this.dividendPayableHoldersSharesRecordedAsLiabilityFg.value,
              constructionContractsLiabilities: this.constructionContractsLiabilitiesFg.value,
              payablesEmployeeBenefitsExpenses: this.payablesEmployeeBenefitsExpensesFg.value,
              payablesVacationDays: this.payablesVacationDaysFg.value,
              payablesHolidayPay: this.payablesHolidayPayFg.value,
              dividendPayableHoldersPreferredShares: this.dividendPayableHoldersPreferredSharesFg.value,
              payablesOtherCurrent: this.payablesOtherCurrentFg.value,
              accrualsAndDeferredIncomeCurrent: this.accrualsAndDeferredIncomeCurrentFg.value,
            },
            kortlopendeSchuldenTekstueel: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.kortlopendeSchulden?.kortlopendeSchuldenTekstueel,
              liabilitiesCurrentDisclosure: this.liabilitiesCurrentDisclosureFg.value,
              convertibleBorrowingsCurrentDisclosure: this.convertibleBorrowingsCurrentDisclosureFg.value,
              debenturesOtherPrivateLoansCurrentDisclosure: this.debenturesOtherPrivateLoansCurrentDisclosureFg.value,
              financeLeaseLiabilitiesCurrentDisclosure: this.financeLeaseLiabilitiesCurrentDisclosureFg.value,
              payablesBanksCurrentDisclosure: this.payablesBanksCurrentDisclosureFg.value,
              advancesReceivedCurrentDisclosure: this.advancesReceivedCurrentDisclosureFg.value,
              tradePayablesCurrentDisclosure: this.tradePayablesCurrentDisclosureFg.value,
              billsExchangeChequesPayableCurrentDisclosure: this.billsExchangeChequesPayableCurrentDisclosureFg.value,
              payablesGroupCompaniesCurrentDisclosure: this.payablesGroupCompaniesCurrentDisclosureFg.value,
              payablesOtherAffiliatedCompaniesCurrentDisclosure: this.payablesOtherAffiliatedCompaniesCurrentDisclosureFg.value,
              payablesShareholdersParticipatingInterestsCurrentDisclosure: this.payablesShareholdersParticipatingInterestsCurrentDisclosureFg.value,
              payablesIncomeTaxCurrentDisclosure: this.payablesIncomeTaxCurrentDisclosureFg.value,
              taxesSocialSecurityContributionsPayableCurrentDisclosure: this.taxesSocialSecurityContributionsPayableCurrentDisclosureFg.value,
              pensionPayablesCurrentDisclosure: this.pensionPayablesCurrentDisclosureFg.value,
              repaymentObligationsOfNoncurrentBorrowingsDisclosure: this.repaymentObligationsOfNoncurrentBorrowingsDisclosureFg.value,
              dividendPayableHoldersSharesRecordedAsLiabilityDisclosure: this.dividendPayableHoldersSharesRecordedAsLiabilityDisclosureFg.value,
              constructionContractsLiabilitiesDisclosure: this.constructionContractsLiabilitiesDisclosureFg.value,
              payablesEmployeeBenefitsExpensesDisclosure: this.payablesEmployeeBenefitsExpensesDisclosureFg.value,
              payablesVacationDaysDisclosure: this.payablesVacationDaysDisclosureFg.value,
              payablesHolidayPayDisclosure: this.payablesHolidayPayDisclosureFg.value,
              dividendPayableHoldersPreferredSharesDisclosure: this.dividendPayableHoldersPreferredSharesDisclosureFg.value,
              payablesOtherCurrentDisclosure: this.payablesOtherCurrentDisclosureFg.value,
              accrualsAndDeferredIncomeCurrentDisclosure: this.accrualsAndDeferredIncomeCurrentDisclosureFg.value,
              liabilitiesCurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosure: this.liabilitiesCurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosureFg.value,
            }
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity)
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
  }
}
